<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild">
      <div class="avater">
        <img src="https://landing.flameendures.com/fengbao/img/nav_to/logo.png" alt="" />
      </div>
      <div
        style="touch-action: none"
        v-if="!emailUrl"
        class="header-btn"
        @click="goToLogin()"
      >
        {{ $t("header.btn") }}
      </div>
      <!-- <div class="header-btn" v-else @click="onClickDown">立即下載</div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { trace } from "../utils";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      sidebarShow: false,
      showPopup: false,
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      headTopShow: false,
      emailUrl: "",
      downUrl: "",
      text: {},
    };
  },
  computed: {
    ...mapState(["email", "language"]),
  },
  watch: {
    email(newVal) {
      this.emailUrl = newVal;
    },
  },
  created() {
    this.emailUrl = this.$store.getters.getEmail;
  },
  mounted() {},
  props: {
    screenType: String,
    uniqueId: String,
  },
  beforeDestroy() {},
  methods: {
    goToLogin() {
      const email = this.$store.getters.getEmail;
      if (!email) {
        trace.clickShowPreRegistrationBtn(this.uniqueId);
        this.$store.dispatch("showPreRegistrationPopup", true);
      }
    },
    async onClickDown() {
      const data = await this.api.getDownUrl(1);
      this.downUrl = data.map.downUrl;
      // 创建一个隐藏的可下载链接
      const link = document.createElement("a");
      link.href = this.downUrl;
      link.style.display = "none";
      // link.download = "LastEvolution:最後的進化"; // 设置下载后的文件名

      // 添加到DOM中触发点击，然后移除
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async getDownUrl() {},
  },
};
</script>
<style lang="scss" scoped>
/* 顶部 */
#header {
  transition: all ease 0.6s;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}
#header .header-top {
  height: 4rem;
  color: #fff;
  background: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .avater {
    width: 15rem;
    padding-left: 1rem;
    box-sizing: content-box;
    position: relative;
  }
  .header-btn {
    min-width: 8.5rem;
    height: 2.5rem;
    background: url("https://landing.flameendures.com/fengbao/img/nav_to/img_ann.png") no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 2.5rem;
    color: #fff;
    font-size: 1.3rem;
    margin-right: 3rem;
    text-wrap: nowrap;
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  #header {
    .header-top {
      height: 12vw;
      .avater {
        width: 45vw;
        padding-left: 1vw;
      }
      .header-btn {
        margin-right: 2vw;
        min-width: 24vw;
        height: 8vw;
        line-height: 8vw;
        font-size: 3.5vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue